import { render, staticRenderFns } from "./ApprovalData.vue?vue&type=template&id=4b1b82aa"
import script from "./ApprovalData.vue?vue&type=script&lang=js"
export * from "./ApprovalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports